const jobs = [
  {
    id: "tech-installer",
    title: "Teknisi Instalasi CCTV",
    location: "Tangerang",
    type: "Full-time",
    summary:
      "Instalasi & perawatan sistem CCTV, DVR/NVR, serta konfigurasi jaringan dan aplikasi mobile.",
    requirements: [
      "Pengalaman instalasi minimal 1 tahun",
      "Menguasai crimping dan basic networking",
      "Memiliki SIM C & bersedia kerja lapangan",
    ],
    benefits: ["Gaji pokok + insentif", "Uang transport", "BPJS Kesehatan"],
  },
  {
    id: "sales-consultant",
    title: "Sales Consultant",
    location: "Tangerang",
    type: "Full-time",
    summary:
      "Menangani konsultasi pelanggan, membuat penawaran, dan mencapai target penjualan.",
    requirements: [
      "Komunikatif & berorientasi target",
      "Berpengalaman di bidang sales minimal 1 tahun",
      "Punya kendaraan pribadi",
    ],
    benefits: ["Gaji pokok + komisi", "Bonus bulanan", "Training produk"],
  },
  {
    id: "admin-cs",
    title: "Admin / Customer Service",
    location: "Tangerang",
    type: "Full-time",
    summary:
      "Melayani pelanggan via telepon/WhatsApp, input data order, dan koordinasi teknisi.",
    requirements: [
      "Minimal SMA/SMK",
      "Mahir Microsoft Office / Google Workspace",
      "Teliti dan komunikatif",
    ],
    benefits: ["Gaji pokok", "BPJS", "Bonus kinerja"],
  },
];

export default jobs;
